<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
input[type="number"] {
    -moz-appearance:textfield; /* Firefox */
}
#textRight .el-input__inner{
  text-align: right !important;
}
.el-input-number__decrease{
  visibility: hidden;
}
.el-input-number__increase{
  visibility: hidden;
}
.el-input-number.is-controls-right .el-input__inner{
  padding-left: 0px;
  padding-right: 0px;
  height: 40px;
}
</style>
<template>
    <div class="card">
        <div class="card-header" style="min-height: 62px;">
          <div class="card-title">
        <button class="btn btn-primary py-3 px-5" @click="setPriceMulti">
              กำหนดราคา
            </button>

            <el-select
              v-model="selectedProCate"
              collapse-tags
              style="margin-left: 20px"
              placeholder="หมวดสินค้า"
              clearable
              filterable 
            >
              <el-option-group
                v-for="group in orderByProductCategoryGroup"
                :key="group.key"
                :label="group.name"
              >
                <el-option
              v-for="item in productCategory.filter(
                (data) =>
                  !group.key ||
                  data.cateGroup.toLowerCase().includes(group.key.toLowerCase())
              )"
                  :key="item.productCategoryCode"
                  :label="item.productCategoryName"
                  :value="item.productCategoryCode"
                >
                </el-option>
              </el-option-group>              
            </el-select>
                &nbsp;&nbsp;
                                    <el-select
                                    v-model="isShowProduct"
                                    collapse-tags
                                    style="width: 150px;"
                                    >
                                        <el-option
                                        v-for="item in showProductionType"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value"
                                        >
                                        </el-option>            
                                    </el-select>
            <div style="margin-left: 10px">
              <label style="color: #909399">หนา </label>
              &nbsp;
                <el-input-number
                  v-model="thicknessFrom"
                  :precision="2"
                  controls-position="right"
                  @click="handleClickInput"
                  @focus="$event.target.select()"
                  style="width: 50px; height: 40px"
                  ref="thicknessFrom"
                  id="textRight"
                />
                &nbsp;
                <label style="color: #909399">ถึง </label>   
                &nbsp;
                <el-input-number
                  v-model="thicknessTo"
                  :precision="2"
                  controls-position="right"
                  @click="handleClickInput"
                  @focus="$event.target.select()"
                  style="width: 50px; height: 40px"
                  ref="thicknessTo"
                  id="textRight"
                />                  
            <button
              style="margin-left: 20px"
              class="btn btn-primary py-3 px-5"
              @click="searchProduct"
            >
              <i class="fa fa-search"></i>
            </button>                                         
            </div>
          </div>
          <div class="card-toolbar">
            <div class="d-flex align-items-center position-relative my-1">
                <span class="svg-icon svg-icon-1 position-absolute ms-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <rect
                opacity="0.5"
                x="17.0365"
                y="15.1223"
                width="8.15546"
                height="2"
                rx="1"
                transform="rotate(45 17.0365 15.1223)"
                fill="black"
              />
              <path
                d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                fill="black"
              />
                </svg>
              </span>
          <input
            type="text"
            v-model="search"
            data-kt-customer-table-filter="search"
            class="form-control form-control-solid w-220px ps-15"
            placeholder="ค้นหา"
          />
            </div>            
          </div>
        </div>
        <div class="card-body p-3">
        <el-table
            ref="multipleTable"
            :data="
              products.filter(
                (data) =>
                  !search ||
                  data.productName.toLowerCase().includes(search.toLowerCase()) ||
                  data.productCode.toLowerCase().includes(search.toLowerCase())
              )
            "          
            style="width: 100%"
            :height="windowHeight"
            :cell-style="{padding: '0', height: '40px'}"
            @selection-change="handleSelectionChange"
            >
            <el-table-column type="selection" width="55" />
        <el-table-column prop="productCode" label="รหัสสินค้า" width="250" sortable>
          <template v-slot="scope">
            <span
              style="color: #009ef7; font-weight: bold; cursor: pointer"
              @click="callPriceHistory(scope.row.productID)"
              >{{ scope.row.productCode }}</span
            >
          </template>            
        </el-table-column>
        <el-table-column prop="productName" label="ชื่อสินค้า" sortable>
              <template v-slot="scope">
            {{ scope.row.productName }} [{{
              numberWithCommas(scope.row.productThickness)
            }}]
              </template>            
            </el-table-column> 
            <el-table-column
            prop="productName"
            label="อัพเดทล่าสุด"
            width="150"
          sortable
        >   
              <template v-slot="scope">
            <span v-if="scope.row.priceUpdateDatetime != null">{{
              formatDateTimeFromISO(scope.row.priceUpdateDatetime)
            }}</span>
              </template>            
            </el-table-column>     
            <el-table-column prop="branchCallName" label="สาขา" align="center" sortable>
                <template v-slot="scope">
                    <span v-if="scope.row.branchID ==1" class="badge bg-primary">
                        {{ scope.row.branchCallName }}
                    </span>
                     <span v-if="scope.row.branchID ==2" class="badge bg-success">
                        {{ scope.row.branchCallName }}
                    </span>
                     <span v-if="scope.row.branchID ==3" class="badge bg-info">
                        {{ scope.row.branchCallName }}
                    </span>
                </template>            
            </el-table-column>         
            <el-table-column
            prop="priceDealer"
            label="ราคา Dealer"
            align="right"
            width="150"
          sortable
        >
              <template v-slot="scope">
                {{ numberWithCommas(scope.row.priceDealer) }}
              </template>
            </el-table-column>             
            <el-table-column
            prop="pricePartner"
            label="ราคา/กก."
            align="right"
          width="150"
        >
              <template v-slot="scope">
                <el-input-number
                  v-model="scope.row.pricePartner"
                  :precision="2"
                  controls-position="right"
                  @click="handleClickInput"
                  @focus="$event.target.select()"
              style="width: 100px; height: 35px"
                  ref="pricePartner"
                  id="textRight"
                />                
              </template>            
            </el-table-column>                      
        </el-table>        
        </div>  
      <div class="card-footer p-2" style="text-align: right">
        <el-button type="primary" @click="setPrice" :loading="buttonLoading"
          >บันทึกราคา</el-button
        >
      </div>
    <set-price-partner-modal
      ref="setPricePartnerModal"
      @refreshdata="searchProduct"
    ></set-price-partner-modal>
    <loading 
      v-model:active="isLoading"
      :loader="dots" 
      :is-full-page="false"/>    
    </div>  
</template>

<script>
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import { numberWithCommas, formatDateTimeFromISO } from "@/utils";
import Swal from "sweetalert2/dist/sweetalert2.js";
import SetPricePartnerModal from "@/components/modals/forms/SetPricePartnerModal";
import _ from "lodash";
import Loading from 'vue-loading-overlay';

export default {
  components: {
    SetPricePartnerModal,
    Loading,
  },  
  data(){
    return{
      windowHeight: window.innerHeight - 305,
      products: [],
      productShow: [],
      buttonLoading: false,
      search: "",
      multipleSelection: [],
      selectedCountRow: 0,
      productCategoryGroup: [],
      productCategory: [],
      selectedProCate: "LG",
      thicknessFrom: null,
      thicknessTo: null,
      isLoading: false,
      showProductionType: [
          {name: "แสดงเฉพาะ FG", value: "FG"},
          {name: "แสดงเฉพาะ Trade", value: "Trade"},
          {name: "แสดงทั้งหมด", value: "All"}
      ],      
      isShowProduct: "FG",
    };
  },
  mounted() {
    setCurrentPageBreadcrumbs("ตั้งราคา", []);
    this.getProductCategory();
    this.searchProduct();
  }, 
  computed: {
    // orderByProductCategory: function () {
    //   return _.orderBy(this.productCategory, 'name')
    // }
    orderByProductCategoryGroup: function () {
      return _.orderBy(this.productCategoryGroup, "sort", "asc");
    },  
  },
  methods: {
    getProductCategory: async function () {
      try {
        const { data } = await ApiService.query("productcategorys");

        this.productCategory = data;

      this.productCategory.forEach((e) => {
          if (!this.productCategoryGroup.find((a) => a.key === e.cateGroup)) {
            this.productCategoryGroup.push({
              key: e.cateGroup,
              name: e.cateGroup,
              sort: e.CategoryShowSort,
            });
          }
      });        
      } catch (error) {
        console.log(error);
      }
    },      
    handleClickInput(){
      this.$emit("pricePartner:focus");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },       
    setPrice: async function(){
      this.buttonLoading = true;

      const newPricePartner = this.products.filter(
        (data) => data.priceDefault != data.pricePartner
      );

      try{
        const { data } = await ApiService.post("partners/UpdatePricePartner", {
          Products: newPricePartner
            .map((data) => data.productID + "|" + data.pricePartner+ "|" +data.branchID)
            .join(","),
        });

        if (data["success"] == 1) {
                  Swal.fire({
                  text: data["error_Text"],
                  icon: "success",
                  showCancelButton: false,
                  showConfirmButton: false,                  
                  allowOutsideClick: false,
                  timer: 1500,
                  }).then(() => {
                    this.searchProduct();
                  });               
            }            
      }catch (error){
                  Swal.fire({
                  text: "เกิดข้อผิดพลาด",
                  icon: "warning",
                  buttonsStyling: false,
                  confirmButtonText: "ปิด",
                  allowOutsideClick: false,
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
        });
      }finally{
        console.log("success");
      }

      this.buttonLoading = false;
    },
    setPriceMulti(){
      if(this.multipleSelection.length > 0){
        this.showSetPriceModal(this.multipleSelection);
      }else{
          this.$message({
            type: "warning",
            message: "กรุณาเลือกรายการสินค้า",
          });        
      }     
    },
    showSetPriceModal(products){
      this.$refs.setPricePartnerModal.show(products);
    },
    // handleChangeProductCategory(){
    //   this.productShow = this.products.filter(data => !this.selectedProCate || data.productCategoryCode.toLowerCase().includes(this.selectedProCate.toLowerCase()));
    // },
    searchProduct: async function (){

      this.isLoading = true;

      const thickFrom =
        this.thicknessFrom == undefined ? 0 : this.thicknessFrom;
      const thickTo = this.thicknessTo == undefined ? 0 : this.thicknessTo;

      const { data } = await ApiService.query(
        "products/GetProductByParam?Cate=" +
          this.selectedProCate +
          "&ThickFrom=" +
          thickFrom +
          "&ThickTo=" +
          thickTo +
          "&IsShowProduct=" +
          this.isShowProduct
      );

      this.products = data;

      this.isLoading = false;
    },
    callPriceHistory(productID){
      this.$router.push({name: "priceHistory" , params: { productID: productID } })
    },
    iRowStyle:function ({row, rowIndex}) {
        return 'height:35px';
    },
    iHeaderRowStyle:function ({row, rowIndex}) {
        return 'height:35px';
    },
    iCellStyle:function ({row, column, rowIndex, columnIndex}) {
        return 'padding:0px'
    },
    iHeaderCellStyle:function ({row, column, rowIndex, columnIndex}) {
        return 'padding:0px'
    },    
    numberWithCommas,
    formatDateTimeFromISO,
  },
};
</script>
